/**
 * Shared status → tone map for the admin workspace queues.
 *
 * Actionable statuses (pending, removal_requested) use signal colors so they
 * stand out; decided statuses use their outcome color consistently on every
 * tab: approved/completed/active = emerald, rejected = rose,
 * suspended/removal_requested = amber, removed/inactive = slate.
 */
export function getAdminStatusTone(status: string): string {
  switch (status) {
    case "approved":
    case "completed":
    case "active":
      return "border-emerald-300/25 bg-emerald-300/10 text-emerald-100";
    case "rejected":
      return "border-rose-300/25 bg-rose-300/10 text-rose-100";
    case "suspended":
    case "removal_requested":
      return "border-amber-300/25 bg-amber-300/10 text-amber-100";
    case "removed":
    case "inactive":
      return "border-slate-400/25 bg-slate-400/10 text-slate-300";
    case "pending":
    default:
      return "border-sky-300/25 bg-sky-300/10 text-sky-100";
  }
}

/** True while a queue item still needs an admin decision. */
export function isActionableStatus(status: string): boolean {
  return status === "pending" || status === "removal_requested";
}
